'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'calendar';
var width = 448;
var height = 512;
var aliases = [128197,128198];
var unicode = 'f133';
var svgPathData = ['M16 192l0 224c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-224-416 0z', 'M120 0c4.4 0 8 3.6 8 8l0 56 192 0 0-56c0-4.4 3.6-8 8-8s8 3.6 8 8l0 56 48 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l48 0 0-56c0-4.4 3.6-8 8-8zm-8 104l0-24-48 0c-26.5 0-48 21.5-48 48l0 48 416 0 0-48c0-26.5-21.5-48-48-48l-48 0 0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24-192 0 0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8zm320 88l-416 0 0 224c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-224z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;